export default __webpack_public_path__ + "static/media/border.9b9080c1.jpg";